/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form'
import { useRequest } from '../../../hooks/UseRequest'
import { selectModules } from '../../../redux/moduleSlice'
import { setNotification } from '../../../redux/notificationSlice'
import Loading from '../../../components/Loading'
import { selectDropdowns, selectDropdownOptions } from '../../../redux/dropdownSlice'
import FormFieldBuilder from "../../../components/FormFieldBuilder";
import { formDataSanitizer } from '../../../helpers/formValidation';
import LayoutSidebar from '../../../components/LayoutSidebar';
import { selectAuth } from '../../../redux/authSlice';
import SpecialInstruction from '../../../components/elements/SpecialInstruction';
import { useNavigate, useParams } from "react-router-dom"
import DisplayField from '../../../components/elements/DisplayField'
import { setSidebarIsActive } from "../../../redux/layoutSlice"
import { generateTableKey } from '../../../utils/listViewHelper'
import { format, parseISO } from 'date-fns';
import Dropzone from 'react-dropzone'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faHistory, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { selectUser } from '../../../redux/userSlice'
import { hasUserPermission } from '../../../utils/permissionHelper'
import { DateFormat } from '../../../helpers/formatting'
import { selectModal, setModal } from '../../../redux/modalSlice'
import Select from 'react-select'
import { reactSelectClassNames } from '../../../helpers/react-select-styles'

export default function Campaign() {
  const dispatch = useDispatch();
  const active = useSelector(selectUser)
  const activePermissions = active.spoofed_user.user_permission_options ? active.spoofed_user.user_permission_options : active.data.user_permission_options
  const [userPermissions, setUserPermissions] = useState()
  const { register, handleSubmit, control, formState: { errors }, setValue, watch } = useForm();
  const [saving, setSaving] = useState(false)
  const request = useRequest()
  const params = useParams()
  const campaignId = params.id ?? null
  const [pageLoaded, setPageLoaded] = useState(false)
  const [campaignInfo, setCampaignInfo] = useState(null)
  const dropdownOptions = useSelector(selectDropdownOptions)
  const [mode, setMode] = useState('add')
  const [testQueryRunning, setTestQueryRunning] = useState(false)

  const [module, setModule] = useState()
  const [moduleFields, setModuleFields] = useState()
  const [promotionModuleFields, setPromotionModuleFields] = useState()
  const navi = useNavigate()
  const modules = useSelector(selectModules)
  const modal = useSelector(selectModal)
  const dropDowns = useSelector(selectDropdowns)
  const [stateFields, setStateFields] = useState([]);
  const auth = useSelector(selectAuth);
  const todayDateTime = format(new Date(), 'yyyy-MM-dd\'T\'HH:mm'); // For datetime-local input type
  const [payFrequencyMonthlyOption, setPayFrequencyMonthlyOption] = useState(null)

  const campaignFields1 = ['name', 'is_active', 'portfolio_id', 'connection_type_dropdown_option_id', 'description']
  const campaignFields2 = ['campaign_type_dropdown_option_id', 'template_id', 'voicemail_filename', 'voicemail_from']
  const campaignFields3 = ['email_from', 'email_subject',]
  const campaignFields4 = ['audience_query_sql', 'suppression_query_sql', 'limit_percent']
  const campaignFields5 = ['campaign_send_type_dropdown_option_id']
  const campaignFields6 = ['scheduled_execution_time', 'scheduled_send_time', 'frequency_dropdown_option_id', 'send_quantity_limit', 'start_date', 'end_date', 'day_of_week_dropdown_option_id', 'week_of_month_dropdown_option_id', 'day_of_month_dropdown_option_id']
  const campaignFields7 = ['trigger_query_sql']
  // const promotionFields1 = ['promotion_id', 'start_date', 'end_date']
  const promotionFields1 = ['promotion_id', 'start_date']

  const promoCampaignFields6 = useMemo(
    () => campaignFields6.filter((field) => field !== "scheduled_send_time"),
    [campaignFields6],
  );

  const promotionTypeDropdown = [
    { value: "single", label: "Single Promotion" },
    { value: "group", label: "Promotion Group" },
  ]
  const promotionExpirationIntervalTypeDropdown = [
    { value: "day_of_month", label: "Day of Month" },
    { value: "number_of_days", label: "Number of Days" },
  ]
  const [selectedPromotionType, setSelectedPromotionType] = useState(promotionTypeDropdown[0])
  const [selectedPromotionExpirationIntervalType, setSelectedPromotionExpirationIntervalType] = useState(promotionExpirationIntervalTypeDropdown[0])

  const [campaignTypeDropdownOptionId, setCampaignTypeDropdownOptionId] = useState(null)
  const [campaignSendTypeDropdownOptionId, setCampaignSendTypeDropdownOptionId] = useState(null)
  const [frequencyDropdownOptionId, setFrequencyDropdownOptionId] = useState(null)
  const [promotionId, setPromotionId] = useState(null)

  const [file, setFile] = useState(null)
  const onDrop = (file) => setFile(file[0])

  const campaignTypes = {
    EMAIL: dropdownOptions?.find((e) => e?.code_key === 'campaign_type_email')?.id,
    SMS: dropdownOptions?.find((e) => e?.code_key === 'campaign_type_sms')?.id,
    VOICEMAIL: dropdownOptions?.find((e) => e?.code_key === 'campaign_type_voicemail')?.id,
    PROMOTION: dropdownOptions?.find((e) => e?.code_key === 'campaign_type_promotion')?.id,
  }

  const campaignSendTypes = {
    SCHEDULED: dropdownOptions?.find((e) => e?.code_key === 'campaign_send_type_scheduled')?.id,
    TRIGGERED: dropdownOptions?.find((e) => e?.code_key === 'campaign_send_type_triggered')?.id,
  }

  const frequencies = {
    DAILY: dropdownOptions?.find((e) => e?.code_key === 'pay_frequency_daily')?.id,
    WEEKLY: dropdownOptions?.find((e) => e?.code_key === 'pay_frequency_weekly')?.id,
    BIWEEKLY: dropdownOptions?.find((e) => e?.code_key === 'pay_frequency_biweekly')?.id,
    SEMIMONTHLY: dropdownOptions?.find((e) => e?.code_key === 'pay_frequency_semimonthly')?.id,
    MONTHLY: dropdownOptions?.find((e) => e?.code_key === 'pay_frequency_monthly')?.id,
  }

  const handleStateFields = (name, value, module) => {
    if (name === 'campaign_type_dropdown_option_id') {
      setCampaignTypeDropdownOptionId(value)
    } else if (name === 'campaign_send_type_dropdown_option_id') {
      setCampaignSendTypeDropdownOptionId(value)
    } else if (name === 'frequency_dropdown_option_id') {
      setFrequencyDropdownOptionId(value)
    } else if (name === 'promotion_id') {
      setPromotionId(value)
    }

    const stateFieldName = `${module.code_key}_${name}`;
    if (stateFields.some((item) => item.name === stateFieldName)) {
      setStateFields(stateFields.map((item) => {
        if (stateFieldName === item?.name) {
          return {
            ...item,
            value: value
          }
        } else {
          return item
        }
      }))
    } else {
      setStateFields([
        ...stateFields,
        {
          name: stateFieldName,
          value: value
        }
      ])
    }
  }

  const slideDownHistory = () => {
    if (modal.is_active === false) {
      dispatch(
        // add here
        setModal({ is_active: true, title: `${module.name} History`, content: `${process.env.REACT_APP_API_DOMAIN}/${module.code_key}/${params.id}/${module.code_key}_audit`, type: 'history', parent_modal: `${module.code_key}` })
      )
    } else {
      dispatch(setModal({ title: `${module.name} History`, content: '', type: '', is_active: false }))
    }
  }

  useEffect(() => {
    if (modules.data.length > 0) {
      const m = modules.data.find((e) => e.code_key === 'campaign')
      if (m) {
        setModule(m)
        const mf = [...m.module_fields]
        mf.sort((a, b) => a.detail_display_rank - b.detail_display_rank)
        setModuleFields(mf)
      }

      const pm = modules.data.find((e) => e.code_key === 'promotion_code')
      if (pm) {
        const pmf = [...pm.module_fields]
        pmf.sort((a, b) => a.detail_display_rank - b.detail_display_rank)
        setPromotionModuleFields(pmf)
      }

      setUserPermissions(activePermissions)
    }
  }, [modules.data])

  useEffect(() => {
    return () => {
      setCampaignInfo(null);
    };
  }, []);

  useEffect(() => {
    if (!auth.fromPageChange) { return }
    if (active.status === 'succeeded' && auth.accessToken && module && dropDowns.data.length > 0) {
      if (campaignId) {
        getCampaignInformation(campaignId)
        setMode('view')
      } else {
        setMode('add')
        setPageLoaded(true)
      }
    }
  }, [active, auth.accessToken, module])

  const getCampaignInformation = async (campaignId) => {
    request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/campaign/view/${campaignId}`)
    try {
      const response = await request.get()
      if (response.status === 200 || response.status === 201) {
        setCampaignInfo(response?.data?.data)
        setPageLoaded(true)

        // set state fields
        setCampaignTypeDropdownOptionId(response?.data?.data?.campaign_type_dropdown_option_id)
        setCampaignSendTypeDropdownOptionId(response?.data?.data?.campaign_send_type_dropdown_option_id)
        setFrequencyDropdownOptionId(response?.data?.data?.frequency_dropdown_option_id)
        setPromotionId(response?.data?.data?.promotion_id)

        // forcesully set the portfolio_id in stateFields
        handleStateFields('portfolio_id', response?.data?.data?.portfolio_id, module)

        // set monthly options
        if (response?.data?.data?.frequency_dropdown_option_id == frequencies.MONTHLY) {
          if (response?.data?.data?.day_of_month_dropdown_option_id) {
            setPayFrequencyMonthlyOption("monthly-option1")
          } else if (response?.data?.data?.day_of_week_dropdown_option_id && response?.data?.data?.week_of_month_dropdown_option_id) {
            setPayFrequencyMonthlyOption("monthly-option2")
          } else {
            setPayFrequencyMonthlyOption(null)
          }
        } else {
          setPayFrequencyMonthlyOption(null)
        }

        if (response?.data?.data?.campaign_type_dropdown_option_id == campaignTypes.PROMOTION) {
          if (response?.data?.data?.promotion_id) {
            setSelectedPromotionType(promotionTypeDropdown[0])
          } else {
            setSelectedPromotionType(promotionTypeDropdown[1])
          }
          if (response?.data?.data?.promotion_end_day_of_month_dropdown_option_id) {
            setSelectedPromotionExpirationIntervalType(promotionExpirationIntervalTypeDropdown[0])
          } else {
            setSelectedPromotionExpirationIntervalType(promotionExpirationIntervalTypeDropdown[1])
          }
        }
      } else {
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
      dispatch(setNotification({ type: 'error', body: errorMessage }))
    }
  }

  const getTestQueryResult = async (eventOrUrl) => {
    setTestQueryRunning(true);

    let endpoint;

    if (typeof eventOrUrl === 'string') {
      // If it's a string, assume it's the URL
      endpoint = eventOrUrl;
    } else {
      eventOrUrl.preventDefault();

      let portfolioId = null;
      let audienceQuery = null;
      let suppressionQuery = null;
      let limitPercent = null;
      let triggerQuery = null;
      let promotionCodeId = null;
      let connectionTypeDropdownOptionId = null;

      if (mode == 'view') {
        portfolioId = campaignInfo?.portfolio_id;
        audienceQuery = campaignInfo?.audience_query_sql;
        suppressionQuery = campaignInfo?.suppression_query_sql;
        limitPercent = campaignInfo?.limit_percent;
        triggerQuery = campaignInfo?.trigger_query_sql;
        promotionCodeId = campaignInfo?.promotion_code_id;
        connectionTypeDropdownOptionId = campaignInfo?.connection_type_dropdown_option_id
      } else {
        portfolioId = watch('portfolio_id');
        audienceQuery = watch('audience_query_sql');
        suppressionQuery = watch('suppression_query_sql');
        limitPercent = watch('limit_percent');
        triggerQuery = watch('trigger_query_sql');
        connectionTypeDropdownOptionId = watch('connection_type_dropdown_option_id');
        if (mode == 'edit') {
          promotionCodeId = campaignInfo?.promotion_code_id;
        }
      }

      const params = new URLSearchParams();
      if (audienceQuery) {
        params.append('audience_query', audienceQuery);
      }
      if (portfolioId) {
        params.append('portfolio_id', portfolioId);
      }
      if (suppressionQuery) {
        params.append('suppression_query', suppressionQuery);
      }
      if (limitPercent) {
        params.append('limit_percent', limitPercent);
      }
      if (campaignSendTypeDropdownOptionId === campaignSendTypes.TRIGGERED && triggerQuery) {
        params.append('trigger_query', triggerQuery);
      }
      if (promotionCodeId) {
        params.append('promotion_code_id', promotionCodeId);
      }

      if (connectionTypeDropdownOptionId) {
        params.append('connection_type_dropdown_option_id', connectionTypeDropdownOptionId)
      }

      endpoint = `${process.env.REACT_APP_API_DOMAIN}/campaign/get_test_query_result?${params.toString()}`;
    }

    request.setEndpoint(endpoint);

    try {
      const response = await request.get();
      if (response.status === 200 || response.status === 201) {
        setTestQueryRunning(false);
        displayTestQueryResult(response.data);
        dispatch(setNotification({ type: 'success', body: 'Success' }));
      } else {
        setTestQueryRunning(false);
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }));
      }
    } catch (error) {
      setTestQueryRunning(false);
      const errorMessage = error?.response?.data?.message || error?.response?.data?.messageExtreme || 'An unexpected error occurred';
      dispatch(setNotification({ type: 'error', body: errorMessage }));
    }
  };

  const displayTestQueryResult = (data) => {
    dispatch(
      setModal({
        is_active: true,
        type: 'campaign_test_run_result_modal',
        options: {
          responseData: data,
          getTestQueryResult: getTestQueryResult
        }
      })
    )
  }

  const onSubmit = async (formData) => {
    if (campaignSendTypeDropdownOptionId === campaignSendTypes.SCHEDULED && frequencyDropdownOptionId === frequencies.MONTHLY && payFrequencyMonthlyOption == null) {
      dispatch(setNotification({ type: 'error', body: 'Monthly Option is required' }))
      return;
    }
    setSaving(true)
    if (formData.promotion_start_date) {
      formData.promotion_start_date = format(parseISO(formData.promotion_start_date), 'yyyy-MM-dd HH:mm:ss')
    }
    if (formData.promotion_end_date) {
      formData.promotion_end_date = format(parseISO(formData.promotion_end_date), 'yyyy-MM-dd HH:mm:ss')
    }
    if (payFrequencyMonthlyOption === "monthly-option1") {
      formData.day_of_week_dropdown_option_id = null
      formData.week_of_month_dropdown_option_id = null
    } else if (payFrequencyMonthlyOption === "monthly-option2") {
      formData.day_of_month_dropdown_option_id = null
    }

    if (formData.campaign_type_dropdown_option_id === campaignTypes.PROMOTION) {
      formData.promotion_type = selectedPromotionType.value
      if (formData.promotion_type === 'single') {
        formData.promotion_group_id = null
      } else if (formData.promotion_type === 'group') {
        formData.promotion_id = null
      }
      formData.promotion_expiration_interval_type = selectedPromotionExpirationIntervalType.value
      if (formData.promotion_expiration_interval_type === 'day_of_month') {
        formData.promotion_number_of_day = null
      } else if (formData.promotion_expiration_interval_type === 'number_of_days') {
        formData.promotion_end_day_of_month_dropdown_option_id = null
      }
    }

    const sanitizedData = formDataSanitizer(formData, module, dropdownOptions)

    try {
      let response = null
      if (mode == "edit") {
        request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/campaign/update/${campaignId}`)
        response = await request.modify(sanitizedData, file)
      } else if (mode == "add") {
        request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/campaign/create`)
        response = await request.post(sanitizedData, file)
      }

      if (response.status === 200 || response.status === 201) {
        setSaving(false)

        setCampaignInfo(response?.data?.data)

        // set state fields
        setCampaignTypeDropdownOptionId(response?.data?.data?.campaign_type_dropdown_option_id)
        setCampaignSendTypeDropdownOptionId(response?.data?.data?.campaign_send_type_dropdown_option_id)
        setFrequencyDropdownOptionId(response?.data?.data?.frequency_dropdown_option_id)
        setPromotionId(response?.data?.data?.promotion_id)

        dispatch(setNotification({ type: 'success', body: '' }))
        navi(`/campaign/${response?.data?.data?.id}`, { state: { reloadPage: true } });
      } else {
        setSaving(false)
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      setSaving(false)
      const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
      dispatch(setNotification({ type: 'error', body: errorMessage }))
    }
  };

  const monthlyOptionsComponent = () => {
    if (mode == "edit" || mode == "add") {
      return (
        <div className="is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2">
          <p className="has-text-grey is-small is-size-8"><span className="mr-1">Monthly Option</span><span className="has-text-danger">*</span></p>
          <Select
            {...register('monthly_options')}
            classNames={reactSelectClassNames()}
            defaultValue={payFrequencyMonthlyOption ? { label: payFrequencyMonthlyOption === "monthly-option1" ? 'Day of Months' : 'Week Day and Week of Month', value: payFrequencyMonthlyOption } : null}
            options={[
              { label: 'Day of Months', value: 'monthly-option1', },
              { label: 'Week Day and Week of Month', value: 'monthly-option2' }
            ]}
            isSearchable={false}
            onChange={(val) => {
              setPayFrequencyMonthlyOption(val.value)
            }}
          />
        </div>
      )
    } else {
      return null;
    }
  }

  const promotionStartDateComponent = () => {
    if (mode == "edit" || mode == "add") {
      return (
        <div className="is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2">
          <p className="has-text-grey is-small is-size-8"><span className="mr-1">Start Date</span><span className="has-text-danger">*</span></p>
          <input
            id="promotion_start_date"
            name="promotion_start_date"
            className="input is-small"
            type="datetime-local"
            placeholder="Start Date"
            defaultValue={campaignInfo?.promotion_start_date}
            {...register('promotion_start_date', {
              required: true
            })}
          />
          <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
            {errors.promotion_start_date && <span>{errors.promotion_start_date.message ? errors.promotion_start_date.message : "Field is required"}</span>}
          </p>
        </div>
      )
    } else if (mode == "view") {
      return (
        <div className="is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2">
          <p className="has-text-grey is-small is-size-8"><span className="mr-1">Start Date</span></p>
          <p><DateFormat dateString={campaignInfo?.promotion_start_date} formatString="MM/dd/yyyy hh:mm:ss a" /></p>
        </div>
      )
    } else {
      return null;
    }
  }

  const promotionEndDateComponent = () => {
    if (mode == "edit" || mode == "add") {
      return (
        <div className="is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2">
          <p className="has-text-grey is-small is-size-8">
            <span className="mr-1">End Date</span>
            <span
              className={`lox-no-border ml-1 lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary`}
              data-tooltip={"End date of the promotion"}
            >
              <FontAwesomeIcon
                icon={faQuestionCircle}
                className="has-text-link"
              />
            </span>
          </p>
          <input
            id="promotion_end_date"
            name="promotion_end_date"
            className="input is-small"
            type="datetime-local"
            placeholder="Start Date"
            defaultValue={campaignInfo?.promotion_end_date}
            {...register('promotion_end_date', {
              required: false
            })}
          />
        </div>
      )
    } else if (mode == "view") {
      return (
        <div className="is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2">
          <p className="has-text-grey is-small is-size-8"><span className="mr-1">End Date</span></p>
          <p><DateFormat dateString={campaignInfo?.promotion_end_date} formatString="MM/dd/yyyy hh:mm:ss a" /></p>
        </div>
      )
    } else {
      return null;
    }
  }

  const voicemailComponent = () => {
    if (mode == "edit" || mode == "add") {
      return (
        <div className="is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2">
          <p className="has-text-grey is-small is-size-8"><span className="mr-1">Voicemail Filename</span></p>
          <Dropzone onDrop={onDrop}>
            {({ getRootProps, getInputProps }) => (
              <div className="columns is-vcentered">
                <div className="column is-half">
                  <section className="container">
                    <div
                      {...getRootProps({ className: 'dropzone' })}
                      className="is-flex is-justify-content-center is-size-5 has-text-weight-bold fa-border is-clickable"
                      style={{ borderColor: 'gray', borderStyle: 'dashed', backgroundColor: 'lightgray' }}
                    >
                      <input {...getInputProps()} />
                      <p>Drop File</p>
                    </div>
                  </section>
                </div>
                <div className="column" style={{ paddingLeft: 0 }}>
                  <span>{file && file.name}</span>
                </div>
              </div>

            )}
          </Dropzone>
        </div>
      )
    } else if (mode == "view" && campaignInfo?.voicemail_s3_link) {
      return (
        <div className="is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2">
          <p className="has-text-grey is-small is-size-8"><span className="mr-1">Voicemail Filename</span></p>
          <div className="column">
            <div className="columns is-vcentered">
              <div className="colmun">
                <a
                  className="button is-primary"
                  href={campaignInfo.voicemail_s3_link}
                  style={{
                    height: '2rem',
                    width: '2rem',
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faEye} />
                </a>
              </div>
              <div className="column">
                <i>{campaignInfo.voicemail_filename}</i>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }

  const getTestRunButton = () => {
    return (
      <button disabled={testQueryRunning} onClick={getTestQueryResult} className="button has-background-grey has-text-white is-small px-2">
        {testQueryRunning ? "Processing..." : "Test Run"}
      </button>
    )
  }

  const formRender = () => {
    if (moduleFields && module) {
      const filterAndSortByCustomFields = (moduleFields, campaignFields) => {
        return moduleFields
          .filter((e) => campaignFields.includes(e.column_name))
          .sort((a, b) => {
            return campaignFields.indexOf(a.column_name) - campaignFields.indexOf(b.column_name);
          });
      };

      const filteredFields1 = filterAndSortByCustomFields(moduleFields, campaignFields1);
      const filteredFields2 = filterAndSortByCustomFields(moduleFields, campaignFields2);
      const filteredFields3 = filterAndSortByCustomFields(moduleFields, campaignFields3);
      const filteredFields4 = filterAndSortByCustomFields(moduleFields, campaignFields4);
      const filteredFields5 = filterAndSortByCustomFields(moduleFields, campaignFields5);
      const filteredFields6 = filterAndSortByCustomFields(moduleFields, campaignFields6);
      const filteredFields7 = filterAndSortByCustomFields(moduleFields, campaignFields7);
      const filteredFields8 = filterAndSortByCustomFields(promotionModuleFields, promotionFields1);

      const renderFields = (fields) => {
        return fields.map((fieldCopy, index) => {
          const m = { ...fieldCopy };
          if (m.module_code_key === 'promotion_code' && m.column_name === 'promotion_id') {
            m.is_required = false;
          }

          // hiding fields based on some other fields
          if (frequencyDropdownOptionId == null || frequencyDropdownOptionId === frequencies.DAILY) {
            if (m.column_name === 'day_of_week_dropdown_option_id' || m.column_name === 'week_of_month_dropdown_option_id' || m.column_name === 'day_of_month_dropdown_option_id') {
              return null;
            }
          } else if (frequencyDropdownOptionId === frequencies.WEEKLY || frequencyDropdownOptionId === frequencies.BIWEEKLY) {
            if (m.column_name === 'week_of_month_dropdown_option_id' || m.column_name === 'day_of_month_dropdown_option_id') {
              return null;
            }
          } else if (frequencyDropdownOptionId === frequencies.MONTHLY) {
            if (payFrequencyMonthlyOption === "monthly-option1") {
              if (m.column_name === 'day_of_week_dropdown_option_id' || m.column_name === 'week_of_month_dropdown_option_id') {
                return null;
              }
            } else if (payFrequencyMonthlyOption === "monthly-option2") {
              if (m.column_name === 'day_of_month_dropdown_option_id') {
                return null;
              }
            } else if (m.column_name === 'day_of_week_dropdown_option_id' || m.column_name === 'week_of_month_dropdown_option_id' || m.column_name === 'day_of_month_dropdown_option_id') {
              return null;
            }
          }

          // hiding fields based on campaign type
          if (campaignTypeDropdownOptionId == null && (m.column_name === 'template_id' || m.column_name === 'voicemail_filename' || m.column_name === 'voicemail_from')) {
            return null;
          }
          if ((m.column_name === 'voicemail_filename' || m.column_name === "voicemail_from") && campaignTypeDropdownOptionId !== campaignTypes.VOICEMAIL && campaignTypeDropdownOptionId != null) {
            return null;
          }
          if (m.column_name === 'template_id' && campaignTypeDropdownOptionId !== campaignTypes.EMAIL && campaignTypeDropdownOptionId !== campaignTypes.SMS && campaignTypeDropdownOptionId != null) {
            return null;
          }

          // hiding fields based on promotion id
          if (m.module_code_key == "promotion_code" && (m.column_name == "start_date" || m.column_name == "end_date")) {
            if (promotionId == null) {
              return null;
            }
          }

          let selectOptions = {};
          const fieldType = dropdownOptions[m.module_field_type_dropdown_option_id]?.code_key;
          if (m.module_code_key === 'campaign' && m.column_name === 'frequency_dropdown_option_id') {
            m.label_name = 'Frequency';
            selectOptions = {
              dropdownOptions: dropDowns?.data.find((e) => m.dropdown_key === e.code_key)?.dropdown_options?.filter((e) => e.code_key !== "pay_frequency_semimonthly"),
              is_editable: true,
              fieldType,
            };
          } else if (m.module_code_key === 'campaign' && m.column_name === 'campaign_send_type_dropdown_option_id' && campaignTypeDropdownOptionId === campaignTypes.PROMOTION) {
            selectOptions = {
              dropdownOptions: dropDowns?.data.find((e) => m.dropdown_key === e.code_key)?.dropdown_options?.filter((e) => e.code_key === "campaign_send_type_scheduled"),
              is_editable: true,
              fieldType,
            };
          } else {
            selectOptions = {
              dropdownOptions: dropDowns?.data.find((e) => m.dropdown_key === e.code_key)?.dropdown_options,
              is_editable: true,
              fieldType,
            };
          }

          // @sadequr TODO: Keep this untill the monthly options are confirmed
          // if (m.module_code_key === 'campaign' && m.column_name === 'day_of_month_dropdown_option_id') {
          //   const weekOfMonthId = watch('week_of_month_dropdown_option_id');
          //   const weekOfMonthCodeKey = dropdownOptions?.find((e) => e?.id === weekOfMonthId)?.code_key
          //   const weekOfMonthValue = weekOfMonthCodeKey?.replace(/week_of_month_/, "");
          //   if (weekOfMonthId) {
          //     selectOptions = {
          //       dropdownOptions: dropDowns?.data.find((e) => m.dropdown_key === e.code_key)?.dropdown_options?.filter((e) => e.name > ((weekOfMonthValue - 1) * 7) && e.name <= (weekOfMonthValue * 7)),
          //       is_editable: true,
          //       fieldType,
          //     };
          //   } else {
          //     selectOptions = {
          //       dropdownOptions: dropDowns?.data.find((e) => m.dropdown_key === e.code_key)?.dropdown_options,
          //       is_editable: true,
          //       fieldType,
          //     };
          //   }
          // }

          if (pageLoaded) {
            if (m.module_code_key == "promotion_code" && m.column_name == "start_date") {
              return promotionStartDateComponent()
            } else if (m.module_code_key == "promotion_code" && m.column_name == "end_date") {
              return promotionEndDateComponent()
            } else if (m.module_code_key == "campaign" && m.column_name == "voicemail_filename") {
              return voicemailComponent()
            }

            if (mode == "edit" && campaignInfo) {
              const fieldNameLookup = {
                portfolio_id: campaignInfo.portfolio_label,
                template_id: campaignInfo.template_label,
                promotion_code_id: campaignInfo.promotion_code_label,
                promotion_id: campaignInfo.promotion_label,
              }

              const defaultValue = fieldNameLookup[m.column_name] || campaignInfo[m.column_name];

              if (!hasUserPermission(activePermissions, 'is_dev') && m.module_code_key == "campaign" && (m.column_name == "audience_query_sql" || m.column_name == "suppression_query_sql" || m.column_name == "trigger_query_sql")) {
                return (
                  <DisplayField
                    data={m}
                    row={campaignInfo}
                    key={m.id}
                    dropdowns={dropDowns}
                    dropdownOptions={dropdownOptions}
                  />
                )
              }

              return (
                <>
                  <FormFieldBuilder
                    field={m}
                    selectOptions={selectOptions}
                    register={register}
                    errors={errors}
                    control={control}
                    key={m.id}
                    row={moduleFields}
                    sourceModule={{
                      id: campaignInfo[m.column_name],
                      name: defaultValue,
                      column_name: m.column_name,
                    }}
                    handleStateFields={(name, value) => { handleStateFields(name, value, module) }}
                    stateFields={stateFields}
                    data={campaignInfo[m.column_name]}
                    additionalOptions={m.module_code_key == "campaign" && m.column_name === 'start_date' ? { min: campaignInfo?.start_date ?? todayDateTime } : null}
                  />
                  {m.module_code_key == "campaign" && m.column_name == "frequency_dropdown_option_id" && frequencyDropdownOptionId == frequencies.MONTHLY && (
                    monthlyOptionsComponent()
                  )}
                </>
              );
            }
            if (mode == "view" && campaignInfo) {
              return (
                <DisplayField
                  data={m}
                  row={campaignInfo}
                  key={m.id}
                  dropdowns={dropDowns}
                  dropdownOptions={dropdownOptions}
                />
              )
            }
            if (mode == "add") {
              return (
                <>
                  <FormFieldBuilder
                    field={m}
                    selectOptions={selectOptions}
                    register={register}
                    errors={errors}
                    control={control}
                    key={m.id}
                    row={moduleFields}
                    handleStateFields={(name, value) => { handleStateFields(name, value, module) }}
                    stateFields={stateFields}
                    additionalOptions={m.module_code_key == "campaign" && m.column_name === 'start_date' ? { min: todayDateTime } : null}
                  />
                  {m.module_code_key == "campaign" && m.column_name == "frequency_dropdown_option_id" && frequencyDropdownOptionId == frequencies.MONTHLY && (
                    monthlyOptionsComponent()
                  )}
                </>
              );
            }
          }
        });
      };

      return (
        <>
          <SpecialInstruction type="is-danger" content={"NOTE: Not for required/transactional emails"} />
          <SpecialInstruction content={"This allows the entry of a marketing email campaign to be pre-scheduled and setup. When the time comes to send, we will get all campaigns that match the Audience and/or Trigger queries and create the emails to send at the configured time. At send time, the CRON will create the campaign_batches record and then all the campaign_email_messages records will be attached to the job record."} />
          {renderFields(filteredFields1)}

          <div className="column is-full py-2">
            <p className="subtitle is-4 has-text-weight-bold">Campaign Type</p>
          </div>
          {renderFields(filteredFields2)}

          {campaignTypeDropdownOptionId === campaignTypes.EMAIL && (
            <>
              <div className="column is-full py-2">
                <p className="subtitle is-4 has-text-weight-bold">Optional Template Overrides</p>
              </div>
              {renderFields(filteredFields3)}
            </>
          )}

          {campaignTypeDropdownOptionId === campaignTypes.PROMOTION && (
            <>
              <div className="column is-full py-2">
                <p className="subtitle is-4 has-text-weight-bold">Promotion Information</p>
              </div>
              {mode == 'view' ? (
                <div className="lox-display-field is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2 false">
                  <p className="lox-display-field__label has-text-grey is-small is-size-8">Promotion Type</p>
                  <p className="lox-display-field__data has-text-dark">{selectedPromotionType.label}</p>
                </div>
              ) : (
                <div className="is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2">
                  <p className="has-text-grey is-small is-size-8">
                    <span className="mr-1">Promotion Type</span><span className="has-text-danger">*</span>
                  </p>
                  <div className="control">
                    <Controller
                      name="promotion_type"
                      control={control}
                      render={({ field }) => (
                        <Select
                          name="promotion_type"
                          {...field}
                          classNames={reactSelectClassNames()}
                          options={promotionTypeDropdown}
                          value={selectedPromotionType}
                          defaultValue={promotionTypeDropdown[0]}
                          onChange={(val) => {
                            setSelectedPromotionType(val)
                          }}
                          styles={{
                            container: (base) => ({ ...base, width: '100%' }),
                            menu: ({ ...css }) => ({ ...css, width: 'max-content' }),
                          }}
                        />
                      )}
                    />
                    <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                      {errors.promotion_type &&
                        <span>{errors.promotion_type.message ? errors.promotion_type.message : 'Promotion Type is required'}</span>}
                    </p>
                    </div>
                </div>
              )}
              {selectedPromotionType.value === 'single' && renderFields(filterAndSortByCustomFields(moduleFields, ['promotion_id']))}
              {selectedPromotionType.value === 'group' && renderFields(filterAndSortByCustomFields(moduleFields, ['promotion_group_id']))}
              <div className="column is-full py-2"></div>
              {mode == 'view' ? (
                <div className="lox-display-field is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2 false">
                  <p className="lox-display-field__label has-text-grey is-small is-size-8">Expiration Interval Type</p>
                  <p className="lox-display-field__data has-text-dark">{selectedPromotionExpirationIntervalType.label}</p>
                </div>
              ) : (
                 <div className="is-one-quarter-widescreen is-one-third-desktop is-half-tablet column py-2">
                  <p className="has-text-grey is-small is-size-8">
                    <span className="mr-1">Expiration Interval Type</span><span className="has-text-danger">*</span>
                  </p>
                  <div className="control">
                    <Controller
                      name="promotion_type"
                      control={control}
                      render={({ field }) => (
                        <Select
                          name="promotion_type"
                          {...field}
                          classNames={reactSelectClassNames()}
                          options={promotionExpirationIntervalTypeDropdown}
                          value={selectedPromotionExpirationIntervalType}
                          defaultValue={promotionExpirationIntervalTypeDropdown[0]}
                          onChange={(val) => {
                            setSelectedPromotionExpirationIntervalType(val)
                          }}
                          styles={{
                            container: (base) => ({ ...base, width: '100%' }),
                            menu: ({ ...css }) => ({ ...css, width: 'max-content' }),
                          }}
                        />
                      )}
                    />
                    <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                      {errors.promotion_type &&
                        <span>{errors.promotion_type.message ? errors.promotion_type.message : 'Promotion Type Expiration Interval is required'}</span>}
                    </p>
                    </div>
                </div>
              )}
              {selectedPromotionExpirationIntervalType.value === 'day_of_month' && renderFields(filterAndSortByCustomFields(moduleFields, ['promotion_end_day_of_month_dropdown_option_id']))}
              {selectedPromotionExpirationIntervalType.value === 'number_of_days' && renderFields(filterAndSortByCustomFields(moduleFields, ['promotion_number_of_day']))}
            </>
          )}

          <div className="column is-full py-2">
            <p className="subtitle is-4 has-text-weight-bold">Audience</p>
          </div>
          <div className="column is-full py-0">
            {getTestRunButton()}
          </div>
          {renderFields(filteredFields4)}

          <div className="column is-full py-2">
            <p className="subtitle is-4 has-text-weight-bold">Send Type</p>
          </div>
          {renderFields(filteredFields5)}

          {campaignSendTypeDropdownOptionId === campaignSendTypes.SCHEDULED && (
            <>
              <div className="column is-full py-2">
                <p className="subtitle is-4 has-text-weight-bold">Scheduled Send</p>
              </div>
              {campaignTypeDropdownOptionId === campaignTypes.PROMOTION ? renderFields(filterAndSortByCustomFields(moduleFields, promoCampaignFields6)) : renderFields(filteredFields6)}
            </>
          )}

          {campaignSendTypeDropdownOptionId === campaignSendTypes.TRIGGERED && (
            <>
              <div className="column is-full py-2">
                <p className="subtitle is-4 has-text-weight-bold">Trigger Based Send</p>
              </div>
              {renderFields(filteredFields7)}
            </>
          )}

          {campaignTypeDropdownOptionId !== campaignTypes.PROMOTION && (
            <>
              <div className="column is-full py-2">
                <p className="subtitle is-4 has-text-weight-bold">
                  Promotion
                  <span
                    className={`lox-no-border ml-1 lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary`}
                    data-tooltip={"If a promotion is selected, the campaign will be associated with the promotion."}
                  >
                    <FontAwesomeIcon
                      icon={faQuestionCircle}
                      className="has-text-link"
                    />
                  </span>
                </p>
              </div>
              {renderFields(filteredFields8)}
            </>
          )}
        </>
      );
    } else {
      return <Loading />;
    }
  };

  const generateActionButtons = () => {
    let listButtons = {
      edit: {
        name: 'edit',
        options: {
          className: `button has-background-grey has-text-white is-small mr-1 header-button`,
          style: { width: '2.5rem' },
          onClick: () => {
            dispatch(setSidebarIsActive({ sidebarIsActive: false }))
            setMode("edit")
          },
          label: 'Edit'
        },
        isEnable: 1,
      },
      history: {
        name: 'history',
        options: {
          className: `button has-background-grey has-text-white is-small header-button`,
          style: { width: '5.5rem' },
          onClick: slideDownHistory,
          label: (<><FontAwesomeIcon icon={faHistory} className="pr-1" /> History </>),
        },
        isEnable: userPermissions && hasUserPermission(userPermissions, `${module.code_key}_update`),
      },
    }

    //filtering buttons that is enable
    listButtons = Object.keys(listButtons).filter((key) => {
      return listButtons[key].isEnable
    }).reduce((result, key) => {
      result[key] = listButtons[key];
      return result;
    }, {});

    //converting to index object
    const indexedList = Object.keys(listButtons).reduce((result, key, idx) => {
      result[idx] = listButtons[key];
      return result;
    }, {});

    const numOfListGroup = Math.ceil(Object.keys(indexedList).length / 2);

    // feed the group of 2 button the array
    let listGroups = [];
    let index = 0;
    for (let i = 0; i < numOfListGroup; i++) {
      const button1 = indexedList[index] ?? null;
      const button2 = indexedList[index + 1] ?? null;

      let group = [];
      if (button1) {
        group.push(button1)
      }

      if (button2) {
        group.push(button2)
      }

      listGroups.push(group)
      index += 2;
    }

    return (
      <>
        {listGroups.map((group) => {
          return generateGroupButton(group)
        })}
      </>
    )
  }

  const generateGroupButton = (group) => {
    let fixedStyle = false
    if (group.length === 2 && group[0].name === 'edit' && group[1].name === 'delete') {
      fixedStyle = { width: '3.5rem' }
    }

    if (group.length === 2 && group[0].name === 'history' && group[1].name === 'edit') {
      fixedStyle = { width: '5.5rem' }
    }

    return (
      <div
        className="header-button-sub-container"
        key={generateTableKey('', 'group-button-item')}
      >
        {group[0] && generateButton(group[0].options, group.length === 1, fixedStyle)}
        {group[1] && generateButton(group[1].options, group.length === 1, fixedStyle)}
      </div>
    )
  }

  const generateButton = (options, isSingle, fixedStyle) => {
    // eslint-disable-next-line no-nested-ternary
    let style = fixedStyle ? fixedStyle : ((isSingle && options.style) ? options.style : {});
    return (
      <button
        type="button"
        className={options.className ?? ''}
        style={style}
        onClick={options.onClick}
        disabled={options.disabled}
        key={generateTableKey('', options.name + '-button-item')}
      >
        <span className="mx-2">{options.label}</span>
      </button>
    )
  }

  return (
    <LayoutSidebar
      contentTitle={mode == "add" ? 'Add Campaign' : (mode == "edit" ? 'Edit Campaign' : campaignInfo?.name)}
      actionButtons={mode == "view" ? generateActionButtons() : ''}
      content={pageLoaded ? (
        <form onSubmit={handleSubmit(onSubmit)} className="lox-form px-1 py-1">
          <div className="columns is-multiline pt-3">
            {formRender()}
          </div>

          {mode == "edit" || mode == "add" ? (
            <div className="lox-form__buttons-wrapper has-text-right">
              <span
                className="has-text-weight-medium has-text-link"
                aria-hidden="true"
                onClick={() => {
                  if (mode == "edit") {
                    setMode("view")
                  } else if (mode == "add") {
                    navi('/campaign')
                  }
                  dispatch(setNotification({ type: '', body: '' }))
                }}
              >
                Cancel
              </span>
              <button
                type="submit"
                className="button is-link is-small ml-5"
                disabled={saving && 'disabled'}
              >
                {saving ? (
                  <>
                    Saving
                    <Loading size="is-size-6" />
                  </>
                ) : 'Save'}
              </button>
            </div>
          ) : null}
        </form>
      ) : <Loading />}
    />
  )
}
